<template>
  <div class="wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-drawer
      title="编辑审批"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="480"
      destroy-on-close
      append-to-body
    >
      <div class="dialog-content">
        <el-form
          size="mini"
          :model="form"
          class="form"
          :rules="rules"
          label-width="82px"
          ref="mainForm"
        >
          <el-form-item label="业务类型：" prop="type_name">
            <el-input v-model="form.type_name" disabled></el-input>
          </el-form-item>
          <el-form-item label="审批类别：" prop="mode">
            <el-radio-group v-model="form.mode">
              <el-radio-button :label="1">会签</el-radio-button>
              <el-radio-button :label="2">或签</el-radio-button>
            </el-radio-group>
            <p class="mwow-yellow" v-if="form.mode === 1">需要所有审批人同意</p>
            <p class="mwow-yellow" v-if="form.mode === 2">一名审批人同意即可</p>
          </el-form-item>
          <el-form-item
            label="审批条件："
            prop="condition"
            v-if="!(originData.type == 2 && onlinePay)"
          >
            <el-radio-group v-model="form.condition">
              <el-radio-button :label="1">无限制</el-radio-button>
              <el-radio-button :label="2">特定条件</el-radio-button>
            </el-radio-group>
            <p class="mwow-yellow" v-if="form.condition === 1">
              此类操作全部需要审批
            </p>
            <div v-if="form.condition === 2">
              <p class="mwow-yellow">条件可多选，满足其中一项即需要审批</p>
              <div
                class="condition-wrap"
                v-for="item in form.condition_item_list"
                :key="item.item_key"
              >
                <el-checkbox v-model="item.status"></el-checkbox>
                {{ itemKeyTranslate(item.item_key) }} ≥
                <el-input
                  v-model="item.item_value"
                  type="number"
                  placeholder="请输入"
                  @change="
                    (v) => {
                      if (v) {
                        item.item_value = Math.abs(Number(v)).toFixed(2);
                      }
                    }
                  "
                ></el-input>
                <span>{{
                  item.item_key === "order_give_class" ? "课时" : "元"
                }}</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="审批人:" prop="staff_ids">
            <el-select
              v-model="form.staff_ids"
              multiple
              style="display: none"
            ></el-select>
            <div class="staff-wrap">
              <p class="text">
                已添加
                <span class="mwow-green">{{ form.staff_ids.length }}</span> 人
              </p>
              <staff-select-dialog
                :staff-ids.sync="form.staff_ids"
                :staff-items.sync="form.staff_items"
              >
                <el-button class="mwow-button success">添加</el-button>
              </staff-select-dialog>
            </div>
            <div class="staff-show" v-show="form.staff_items.length > 0">
              <span v-for="item in form.staff_items" :key="item.staff_id">{{
                item.name
              }}</span>
            </div>
          </el-form-item>
          <!-- v2.36.x，开通和未开通线上支付，都开启退款人 -->
          <el-form-item
            label="退款人:"
            prop="confirm_staff_ids"
            v-if="originData.type == 2"
          >
            <el-select
              v-model="form.confirm_staff_ids"
              multiple
              style="display: none"
            ></el-select>
            <div class="staff-wrap">
              <p class="text">
                已添加
                <span class="mwow-green">{{
                  form.confirm_staff_ids.length
                }}</span>
                人
              </p>
              <staff-select-dialog
                :staff-ids.sync="form.confirm_staff_ids"
                :staff-items.sync="form.confirm_staff_items"
              >
                <el-button class="mwow-button success">添加</el-button>
              </staff-select-dialog>
            </div>
            <div
              class="staff-show"
              v-show="form.confirm_staff_items.length > 0"
            >
              <span
                v-for="item in form.confirm_staff_items"
                :key="item.staff_id"
                >{{ item.name }}</span
              >
            </div>
          </el-form-item>
          <el-form-item label="抄送人:" prop="copy_staff_ids">
            <el-select
              v-model="form.copy_staff_ids"
              multiple
              style="display: none"
            ></el-select>
            <div class="staff-wrap">
              <p class="text">
                已添加
                <span class="mwow-green">{{ form.copy_staff_ids.length }}</span>
                人
              </p>
              <staff-select-dialog
                :staff-ids.sync="form.copy_staff_ids"
                :staff-items.sync="form.copy_staff_items"
              >
                <el-button class="mwow-button success">添加</el-button>
              </staff-select-dialog>
            </div>
            <div class="staff-show" v-show="form.copy_staff_items.length > 0">
              <span
                v-for="item in form.copy_staff_items"
                :key="item.staff_id"
                >{{ item.name }}</span
              >
            </div>
          </el-form-item>
        </el-form>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="handleClose">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              确定
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { approvalRuleEditApi, approvalRuleEditData } from "@/api/approve";
import staffSelectDialog from "./staffSelectDialog.vue";

export default {
  name: "approveRuleEditDialog",
  components: {
    staffSelectDialog,
  },
  // @Prop() originData!: any;
  // @Prop() onlinePay?: boolean;
  props: ["originData", "onlinePay"],
  data() {
    return {
      form: {
        type: 1,
        type_name: "",
        mode: 1,
        condition: 1,
        condition_item_list: [],
        staff_ids: [],
        staff_items: [],
        copy_staff_ids: [],
        copy_staff_items: [],
        confirm_staff_ids: [],
        confirm_staff_items: [],
      },
      dialogVisible: false,
      rules: {
        mode: [
          { required: true, message: "请选择审批类别", trigger: "change" },
        ],
        condition: [
          { required: true, message: "请选择审批条件", trigger: "change" },
        ],
        staff_ids: [
          { required: true, message: "请选择审批人", trigger: "change" },
        ],
        confirm_staff_ids: [
          { required: true, message: "请选择退款人", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    typeTranslate(v) {
      switch (v) {
        case 1:
          return "购课";
        case 2:
          return "退课";
        case 3:
          return "转课";
      }
      return "";
    },
    itemKeyTranslate(v) {
      switch (v) {
        case "order_give_class":
          return "赠送课时";
        case "order_discount_amount":
          return "直减金额";
        case "order_refund_amount":
          return "退课金额";
      }
    },
    openDialog() {
      this.form.mode = this.originData.mode;
      this.form.type = this.originData.type;
      this.form.type_name = this.typeTranslate(this.originData.type);
      this.form.staff_items = this.originData.staff_list;
      this.form.staff_ids = this.originData.staff_list.map((item) => {
        return item.staff_id;
      });
      this.form.copy_staff_items = this.originData.copy_staff_list;
      this.form.copy_staff_ids = this.originData.copy_staff_list.map((item) => {
        return item.staff_id;
      });
      // 支持线上支付且为退款时才有退款确认人confirm_staff
      if (this.originData.type === 2) {
        this.form.confirm_staff_items = this.originData.confirm_staff_list;
        this.form.confirm_staff_ids = this.originData.confirm_staff_list.map(
          (item) => {
            return item.staff_id;
          }
        );
      }
      this.form.condition = this.originData.condition;
      this.form.condition_item_list = this.originData.condition_item_list.map(
        (item) => {
          return {
            status: item.status === 1,
            item_key: item.item_key,
            item_value: item.item_value,
          };
        }
      );
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          let condition_item_list = this.form.condition_item_list.map(
            (item) => {
              return {
                status: item.status ? 1 : 2,
                item_key: item.item_key,
                item_value: item.item_value,
              };
            }
          );
          if (this.form.condition === 2) {
            condition_item_list = condition_item_list.filter((item) => {
              return item.status === 1;
            });
            // 特定条件时至少勾选一项
            if (condition_item_list.length === 0) {
              this.$message({
                type: "warning",
                message: "至少勾选一项",
              });
              return false;
            }
            // 输入值校验
            let pass = true;
            let msg = "";
            condition_item_list.map((item) => {
              const v = Number(item.item_value);
              if (0 >= v || v > 10000) {
                msg = "输入值应大于0且小于10000";
                pass = false;
              }
            });
            if (!pass) {
              this.$message({
                type: "warning",
                message: msg,
              });
              return false;
            }
          }
          const params = {
            mode: this.form.mode,
            type: this.form.type,
            condition: this.form.condition,
            condition_item_list: condition_item_list,
            staff_ids: this.form.staff_ids,
            copy_staff_ids: this.form.copy_staff_ids,
          };
          //  v2.36.x，开通和未开通线上支付，都开启退款人
          if (this.originData.type === 2) {
            if (this.form.confirm_staff_ids.length > 0) {
              params.confirm_staff_ids = this.form.confirm_staff_ids;
            }
          }
          approvalRuleEditApi(params).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.$emit("change");
              this.dialogVisible = false;
            }
            if (res.error_code === 21024005) {
              this.$confirm(
                `员工角色未选择 “财务中心 - 审批记录 - 审批管理” 权限，请联系门店其他工作人员开启。`,
                `权限提示 - ${res.message}`,
                {
                  cancelButtonText: "取消",
                  cancelButtonClass: "mwow-button-filled info",
                  showConfirmButton: false,
                  showClose: false,
                  type: "warning",
                }
              );
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: inline-block;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.form {
  flex: 1;
  margin: 16px 18px;
  width: 72%;
  .staff-wrap {
    color: #5c5d5e;
    font-size: 12px;
    display: flex;
    .text {
      flex: 1;
    }
  }
  .staff-show {
    background: #f7f7f7;
    padding: 18px;
    margin-top: 17px;
    span {
      &::after {
        content: ",";
      }
      &:last-child::after {
        display: none;
      }
    }
  }
  /deep/.condition-wrap {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #5c5d5e;
    margin-bottom: 14px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-checkbox {
      margin-right: 10px;
      height: 16px;
      line-height: 16px !important;
      font-size: 0;
    }
    .el-input {
      margin: 0 8px;
      width: 100px;
    }
  }
}
.footer {
  margin: 0 18px;
  padding: 23px 0;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
</style>
